import services from 'utils/mockAdapter';
// user list
const Manufacturers = [
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    },
    {
        id: '10011',
        manufacturer: 'Savaria',
        name: 'Savaria ',
        phone: '+1-917-440-9658',
        conatctperson: 'Don Peterson ',
        modelscount: '12',
        dealerscount: '2',
        jobscount: '23'
    }
];
// ==============================|| MOCK SERVICES ||============================== //
services.onGet('/api/manufacturers/manufacturer/list').reply(200, { Manufacturers });
